import { LiveChatContainer, useLiveChatCta } from '@leagueplatform/live-chat';
import {
  queryHelpers,
  useMediaQuery,
  GDSModalContentProps,
} from '@leagueplatform/genesis-core';
import { useLiveChatFloatingBubbleEnabled } from 'hooks/use-live-chat-floating-bubble-enabled.hook';
import { LiveChatCTA, type LiveChatCTAProps } from './live-chat-cta.component';

type LiveChatProps = {
  layout?: GDSModalContentProps['layout'];
} & LiveChatCTAProps;

export function LiveChat({
  layout = 'bottomRight',
  liveChatAnalyticsContext,
}: LiveChatProps) {
  const { isVisible } = useLiveChatCta();
  const isFloatingBubbleEnabled = useLiveChatFloatingBubbleEnabled();
  const isMobile = useMediaQuery(queryHelpers.down('mobileLandscape'));

  return (
    <>
      {isVisible && isFloatingBubbleEnabled ? (
        <LiveChatCTA liveChatAnalyticsContext={liveChatAnalyticsContext} />
      ) : null}
      <LiveChatContainer
        layout={isMobile ? 'fullscreen' : layout}
        css={{
          // Keep chat below `$modal` so the session-timeout warning (a genesis
          // Modal at `$modal`) always renders above it and stays clickable. At
          // `$modal` the two tie and the warning can be hidden behind the chat.
          zIndex: isMobile ? '$tooltip' : '$sticky',
        }}
      />
    </>
  );
}
